import { PLATFORM_FEATURES } from '@application/config';

export enum EIntegrationsIds {
    CERTIFICATES = 'certificates',
    INVOICE = 'invoice',
    CREDENTIALS = 'credentials',
    API_KEY = 'api-key',
    NOTA_FISCAL = 'nota-fiscal',
    WEBHOOK_SETTINGS = 'webhook-settings',
    SCHOOL_CLASSES = 'school-classes',
}

export const integrationsPageFragments = [
    {
        title: 'SETTINGS.INTEGRATIONS.API_KEY.TITLE',
        id: EIntegrationsIds.API_KEY,
    },
    {
        title: 'SETTINGS.INTEGRATIONS.WEBHOOK_SETTINGS.TITLE',
        id: EIntegrationsIds.WEBHOOK_SETTINGS,
    },
    {
        title: 'SETTINGS.INTEGRATIONS.NOTA_FISCAL.TITLE',
        id: EIntegrationsIds.NOTA_FISCAL,
    },
    {
        title: 'SETTINGS.INTEGRATIONS.SCHOOL_CLASSES.TITLE',
        id: EIntegrationsIds.SCHOOL_CLASSES,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
];